/** @deprecated please use fazzBizzThemeFds3 colors theme instead */
export enum YELLOW {
  S400 = '#8D7700',
  S300 = '#E5C412',
  S100 = '#FFFBE9',
}
